import React from 'react';

export default function CertificateByLetter() {
  return (
    <svg width="43" height="43" viewBox="0 0 43 43" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M42.9624 17.8472V42.8011H0.00886023L15.6367 29.1604L0 17.8472L21.4812 0L42.9624 17.8472Z" fill="#FFD54F"/>
      <path d="M3.93555 4.21484H38.8022V31.2811H3.93555V4.21484Z" fill="#EEEFEE"/>
      <path d="M6.69922 6.96582H21.6585V7.87591H6.69922V6.96582Z" fill="#DBD8DD"/>
      <path d="M6.69922 11.5215H25.1044V12.4316H6.69922V11.5215Z" fill="#DBD8DD"/>
      <path d="M28.0586 11.5215H36.0391V12.4316H28.0586V11.5215Z" fill="#DBD8DD"/>
      <path d="M6.69922 16.0762H13.6256V16.9863H6.69922V16.0762Z" fill="#DBD8DD"/>
      <path d="M15.7068 16.0762H36.039V16.9863H15.7068V16.0762Z" fill="#DBD8DD"/>
      <path d="M6.69922 20.6309H21.2111V21.5409H6.69922V20.6309Z" fill="#DBD8DD"/>
      <path d="M23.8291 20.6309H36.0388V21.5409H23.8291V20.6309Z" fill="#DBD8DD"/>
      <path d="M36.0388 25.1875V26.0976H6.69922V25.1875" fill="#DBD8DD"/>
      <path d="M27.3259 29.1609L42.9538 42.8015H42.9626V17.8477L27.3259 29.1609Z" fill="#FFC107"/>
      <path d="M15.6367 29.1609L0.00886023 42.8015H0V17.8477L15.6367 29.1609Z" fill="#FFC107"/>
      <path d="M42.9534 42.8008H0.00878906L15.6366 29.1602H27.3256L42.9534 42.8008Z" fill="#FFA000"/>
    </svg>

  );
}
